import { onLCP, onINP, onCLS, onTTFB, onFCP, type Metric } from 'web-vitals';
import { isPerfEnabled } from '@/core/performance/performanceMarking.service';
import router from '@/router';

let currentRoute = '';

function logMetric(metric: Metric) {
    const rating = metric.rating;
    const value = metric.value;
    const name = metric.name;
    const route = currentRoute || window.location.pathname;

    const style = rating === 'good'
        ? 'color: #16a34a; font-weight: bold'
        : rating === 'needs-improvement'
            ? 'color: #d97706; font-weight: bold'
            : 'color: #dc2626; font-weight: bold';

    console.debug(
        `%c[WebVitals] ${name}: ${value.toFixed(2)} (${rating}) %c| ${route}`,
        style,
        'color: #6b7280'
    );
}

export function initWebVitals() {
    if (!isPerfEnabled()) return;

    // Resource Timing buffer defaults to 250 entries — SPA navigations with many
    // images overflow it and drop API entries before we can read them.
    performance.setResourceTimingBufferSize(4096);

    console.debug(`%c[Perf] flags: webvitals=on | ${window.location.pathname}`, 'color: #2563eb; font-weight: bold');

    router.afterEach((to) => {
        currentRoute = to.path;
    });

    onLCP(logMetric, { reportSoftNavs: true });
    onINP(logMetric, { reportSoftNavs: true });
    onCLS(logMetric, { reportSoftNavs: true });
    onTTFB(logMetric, { reportSoftNavs: true });
    onFCP(logMetric, { reportSoftNavs: true });

    const longTaskObserver = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
            const container = entry as LongTaskWithContainer;
            const attribution = container.containerName || container.containerSrc || container.containerId
                ? ` in ${container.containerType ?? 'unknown'}: ${container.containerName || container.containerSrc || container.containerId}`
                : '';
            console.debug(
                `%c[Perf] long task: ${entry.duration.toFixed(0)}ms${attribution} | ${currentRoute || window.location.pathname}`,
                'color: #dc2626'
            );
        }
    });
    longTaskObserver.observe({ type: 'longtask', buffered: true });
}

interface LongTaskWithContainer extends PerformanceEntry {
    containerType?: string;
    containerName?: string;
    containerSrc?: string;
    containerId?: string;
}
